// eslint-disable-next-line import/prefer-default-export
export const to2dp = (num) => Math.round(num * 100) / 100;
